import axios, { AxiosPromise } from 'axios';
import config from '@/config';
import { Sample, SampleBatch } from '@/modules/analysis/models/analysisRequest';

const resourceEndpoint = `${config.api.url}${config.api.privateEndpointsPrefix}${config.api.endpoints.sampleBatch}`;

export function read(id: string): AxiosPromise<SampleBatch> {
  return axios.get(`${resourceEndpoint}/${id}`, {
    withCredentials: true,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  });
}

export function findFactSamplesBySampleBatchId(id: string): AxiosPromise<Sample[]> {
  return axios.get(`${resourceEndpoint}/${id}/samples/facts`, {
    withCredentials: true,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  });
}

export function readBarcode(barcode: string): AxiosPromise<SampleBatch> {
  return axios.get(`${resourceEndpoint}/barcode/${barcode}`, {
    withCredentials: true,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  });
}
